import React from 'react';
import "../../../components/calcInputs/calcInputs.css"

const UsersInputs = (props) => {

    return ( 
        <>
            <div className="inputsBox">
                <form id="calcForm" noValidate>
                    <div className="fullRow">
                        <div className="mainRow2">
                            <div className="row">
                                <div className="rCol1">
                                    <label htmlFor="actualUserName">
                                    Nazwa <span className="requiredStar">*</span>
                                    <input type="text" id="actualUserName" name="actualUserName" value={props.actualUserName} onChange={props.handleActualUserNameChange}/>
                                    </label>
                                </div>
                                <div className="rCol2">
                                    <label htmlFor="actualUserMail">
                                    Mail uzytkownika <span className="requiredStar">*</span>
                                    <input type="text" id="actualUserMail" name="actualUserMail" value={props.actualUserMail} onChange={props.handleActualUserMailChange}/>
                                    </label>
                                </div>
                                <div className="rCol3">
                                    <label htmlFor="actualUserPhone">
                                    Telefon Uzytkownika<span className="requiredStar">*</span>
                                    <input type="text" id="actualUserPhone" name="actualUserPhone" value={props.actualUserPhone} onChange={props.handleActualUserPhoneChange}/>
                                    </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="rCol1">
                                    <label htmlFor="actualUserType">Rodzaj uzytkownika <span className="requiredStar">*</span></label>
                                    <select name="actualUserType" id="actualUserType" onChange={props.handleActualUserTypeChange} value={props.actualUserType}>
                                        <option value='Wybierz...'>Wybierz rodzaj</option>
                                        <option value="user">user</option>
                                        <option value="admin">admin</option>
                                    </select>
                                </div>
                                <div className="rCol2">
                                    <label htmlFor="actualUserCompanyID">Wybierz firmę <span className="requiredStar">*</span></label>
                                    <select name="actualUserCompanyID" id="actualUserCompanyID" onChange={props.handleActualUserCompanyIDChange} value={props.actualUserCompanyID}>
                                        <option value='Wybierz...'>Wybierz firmę</option>
                                        {props.companiesList.map((company) => (
                                            <option value={company.id}>{company.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="rCol3">
                                    <label htmlFor="actualUserPassword">
                                    Hasło <span className="requiredStar">*</span>
                                    <input type="password" id="aactualUserPassword" name="actualUserPassword" value={props.actualUserPassword} onChange={props.handleActualUserPasswordChange}/>
                                    </label>
                                </div>
                            </div>

                            <div className="row">
                                <div className="rCol1_4">
                                <button className="buttonSubForm" onClick={props.handleAddUser}>DODAJ</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
        </>
     );
}
 
export default UsersInputs;